import { combineReducers } from "redux";
import DetailsReducer from "./DetailsReducer";
import SideBarReducer from "./SideBarReducer";
import SearchValue from "./SearchValue";
import CategoryReducer from "./CategoryReducer";
import WatchlistReducer from "./WatchlistReducer";
import TrailerReducer from "./TrailerReducer";
import ModeReducer from "./ModeReducer";
import ShowReducer from "./ShowReducer";
import LoadingReducer from "./LoadingReducer";


const Compose = combineReducers({DetailsReducer,SideBarReducer,SearchValue,CategoryReducer,WatchlistReducer,TrailerReducer,ModeReducer,ShowReducer,LoadingReducer});

export default Compose;